import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { Sites } from '../config-common';

import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowAdd, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { FormControl, Validators } from '@angular/forms';
import { AllSites } from 'src/models';


@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrls: ['./sites.component.css'],
  providers: [MainGridService]
})
export class SitesComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    public permissionsService: PermissionsService,
    public mainGridService: MainGridService<any>) { }

  sites = this.mainGridService.getAll(
    'Config/GetSitesForEditing',
    'Config/SaveSite');

  initialTableElement;
  canCreate = this.permissionsService.canCreate(this.permissionsService.ComponentID.Config);
  canUpdate = this.permissionsService.canCreate(this.permissionsService.ComponentID.Config);

  tablePermissions: AimsCommonTablePermissions = {
    create: this.canCreate,
    update: this.canUpdate,
    delete: false,
    export: false
  }
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean'},
    { key: 'siteName', label: 'Site Name', type:  AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.required, Validators.maxLength(50)]  },
    { key: 'siteCode', label: 'Site Code', type:  AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.required, Validators.maxLength(4)]  },
    { key: 'payrollSiteName', label: 'Payroll Site Name', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.maxLength(50)]  },
    { key: 'payrollSiteCode', label: 'Payroll Site Code', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.maxLength(4)] },
    { key: 'travelSiteCode', label: 'Travel Site Code', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.maxLength(4)] },
    { key: 'travelMgmtsiteCode', label: 'Travel MGMT Site Code', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.maxLength(4)] },
    { key: 'hasFastPlant', label: 'Has Fast Plant', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean'},
    { key: 'isDefault', label: 'Is Default', type: AimsCommonTableHeaderType.BOOLEAN, filterType:'boolean'},
  ]

  handleRowUpdate(update: TableRowUpdate){
    //payrollSiteId is used in reporting GetStatusForWeek and timekeeping
    //But only default payrollSiteId to 0 if payrollSiteName/Code is filled in
    var row = update.newRow as AllSites;
    if(row.payrollSiteCode || row.payrollSiteName){
      row.payrollSiteId = "0";
    }else{
      row.payrollSiteId = null
    }
    this.mainGridService.update(row, update.index).subscribe();
  }
  handleRowAdd(update: TableRowUpdate){
    var row = update.newRow as AllSites;
    if(row.payrollSiteCode || row.payrollSiteName){
      row.payrollSiteId = "0";
    }else{
      row.payrollSiteId = null
    }

    this.mainGridService.add(row).subscribe();
  }

  ngOnInit(): void {
    this.initialTableElement = new Sites();
  }

}
